import OfferInterface from 'interfaces/offer.interface';
import { ProductUrlParams } from 'modules/product/interfaces/product-url-params.interface';
import DealerInterface from 'interfaces/dealer.interface';

export default function getPromotedOffer(
    offers: OfferInterface[],
    productUrlParams?: ProductUrlParams,
    dealers?: DealerInterface[]
): OfferInterface {
    const dealerId = Number(productUrlParams?.query?.sklep);

    if (dealerId) {
        const offer = offers.find(item => item.dealer.id === dealerId);

        if (offer) {
            return offer;
        }
    }

    const booster = productUrlParams?.query?.booster;

    if (booster === 'false') {
        return offers.sort((offer1, offer2) => offer1.price - offer2.price)[0];
    }

    if (dealers?.length) {
        const offer = dealers.reduce<OfferInterface | null>((offer, dealer) => {
            if (offer) {
                return offer;
            }

            return offers.find(item => item.dealer.id === dealer.id) || null;
        }, null);

        if (offer) {
            return offer;
        }
    }

    return offers[0];
}
